import { RouteLocationNormalized } from 'vue-router';
import { getFirstQueryParam } from '~/utils/common';
import { navigateTo } from '#imports';
import { useOrganizationStore } from '~/store/organization';
import { resolveDefaultLandingUrl } from '~/composables/use-default-landing-url';

export const socialStateRedirect = (to: RouteLocationNormalized) => {
  const { organization } = storeToRefs(useOrganizationStore());
  const state = getFirstQueryParam(to.query.state);

  if (!state) {
    return navigateTo(resolveDefaultLandingUrl(organization.value));
  }

  const socialRedirectUrlHex = state.slice(state.indexOf('-') + 1);

  const socialRedirectUrl = Buffer.from(socialRedirectUrlHex, 'hex').toString();

  try {
    const url = new URL(socialRedirectUrl);

    const queryParams = to.fullPath.slice(to.fullPath.indexOf('?') + 1);

    return navigateTo(
      `${url.origin}${to.path.replace('oauth2', 'auth')}?${queryParams}`,
      {
        external: true,
      },
    );
  } catch {
    return navigateTo(resolveDefaultLandingUrl(organization.value));
  }
};
